import { BoundedContent, Breadcrumb, BreadcrumbList, BreadcrumbsContainer, Link } from '@vp/swan';
import { __, __url } from '@99designs/i18n';

interface BreadcrumbsProps {
    crumbs: Breadcrumbs;
}

export type Breadcrumbs = Array<{ url: string; label: string }>;

export function Breadcrumbs({ crumbs }: BreadcrumbsProps) {
    const breadcrumbList = [
        {
            url: __url('vistaprint.com'),
            label: __('Home'),
        },
        {
            url: __url('/design'),
            label: __('Design Services'),
        },
        ...crumbs,
    ];

    const breadcrumbData = {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbList.map((crumb, i) => ({
            position: i + 1,
            '@type': 'ListItem',
            item: { '@id': crumb.url, name: crumb.label },
        })),
    };

    return (
        <>
            <script
                id="breadcrumb-structured-data"
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
            />

            <BoundedContent>
                <BreadcrumbsContainer>
                    <BreadcrumbList>
                        {breadcrumbList.map((crumb, i) =>
                            i === breadcrumbList.length - 1 ? (
                                <Breadcrumb aria-current="page" key={i}>
                                    {crumb.label}
                                </Breadcrumb>
                            ) : (
                                <Breadcrumb key={i}>
                                    <Link href={crumb.url}>{crumb.label}</Link>
                                </Breadcrumb>
                            )
                        )}
                    </BreadcrumbList>
                </BreadcrumbsContainer>
            </BoundedContent>
        </>
    );
}
